import { useState } from 'react';

import * as Api from '../../services/api';
import AppButtons from '../../components/Common/AppButtons';
import Notification from '../../services/notification';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import FormControl from '@mui/joy/FormControl';
import Input from '@mui/joy/Input';
import Button from '@mui/joy/Button';

export default function EmailCaptureForm() {
  const [email, setEmail] = useState('');
  const [showEmailInput, setShowEmailInput] = useState(true);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();

    try {
      await Api.captureBetaEmail(email);
      Notification.success('Thanks for joining!');
      setEmail('');
      setShowEmailInput(false);
    } catch (err) {
      console.error(err);
      Notification.error();
    }
  };

  return (
    <Box sx={{
      width: '80vw',
      display: 'flex',
      flexDirection: 'column',
      flexFlow: 'column wrap',
      gap: 2,
      mb: 10,
    }}>
      <Typography level="display1" sx={{ mb: -3 }}>get early access</Typography>
      <Typography level="h4" sx={{ pb: 5 }}>Be the first to know when you can buy a premium <b>&tag</b> for your <span className="and-logo">&</span>.<br />Because your <span className="and-logo">&</span> wants some 💧.</Typography>
      {showEmailInput ? (
        <FormControl>
          <Input
            variant="hero"
            placeholder="you@domain.com"
            startDecorator={
              <FontAwesomeIcon icon={faEnvelope} />
            }
            endDecorator={
              <Button onClick={handleEmailSubmit} size="md" >
                Sign up
              </Button>
            }
						// put this somewhere else 
            sx={{
              '--Input-radius': '50px',
              '--Input-gap': '10px',
              '--Input-minHeight': '65px',
              '--Input-paddingInline': '20px',
              '--Input-decorator-childHeight': '50px',
              margin: '0 auto',
              width: '500px',
              maxWidth: '80vw',
            }}
            value={email}
            onChange={(e) => setEmail(e.currentTarget.value)}
          />
        </FormControl>) : (
          <>
          <Typography level="h4" sx={{ pb: 5 }}>Thanks for signing up! We'll be in touch soon. <br />Meanwhile, you can download the <span className="and-logo">&</span> app to get started.
          </Typography>
          <AppButtons />
          </>
      )}
    </Box>
  );
}
